// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import voteBallotEntity from './entities/vote-ballot.json';
import voteBallotMenu from '../pages/vote-ballot/menu.json';
import voteBallotFullForm from '../pages/vote-ballot/forms/full.json';
import voteBallotContextForm from '../pages/vote-ballot/forms/context.json';
import voteBallotMiniForm from '../pages/vote-ballot/forms/mini.json';
import voteBallotLookupForm from '../pages/vote-ballot/forms/lookup.json';
import voteBallotTableView from '../pages/vote-ballot/views/table.json';
import voteBallotCardsView from '../pages/vote-ballot/views/cards.json';
import voteBallotDashboardView from '../pages/vote-ballot/views/dashboard.json';

/** Тип запису «Бюлетень» зі сторінками пакета: меню, форми та подання з pages/vote-ballot/. */
export const voteBallotDefinition: IRecordTypeDefinition = {
  ...voteBallotEntity,
  views: assembleViewSet({
      table: voteBallotTableView,
      cards: voteBallotCardsView,
      dashboard: voteBallotDashboardView,
  }),
  form: voteBallotFullForm,
  forms: { full: voteBallotFullForm, context: voteBallotContextForm, mini: voteBallotMiniForm, lookup: voteBallotLookupForm },
  menu: voteBallotMenu,
} as IRecordTypeDefinition;
